import React, { useEffect, useState, useRef, useContext } from 'react';
import Modal from '../../../components/modal/modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBalanceScaleLeft,
  faTrash,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import Card from '../../../components/card.component';
import {
    Row,
    Col,
} from 'react-bootstrap';
import functions from '../facturacion.functions';
import DataTable from 'react-data-table-component';
import utils from '../../../utils/utils.functions';
import notification from '../../../components/notification.component';
import { ConfigContextUtils } from '../../../context/contextUtils.context';
import { ConfigContext } from '../../../context/config.context';
import { v4 as uuidv4 } from 'uuid';


export default function AjusteBoletaModal({ boletaId, estado }) {

    const { setPreloader } = useContext(ConfigContextUtils);
    const { config } = useContext(ConfigContext);
    const [visible, setVisible] = useState(false);
    const [detalle, setDetalle] = useState(null);
    const [montoajuste, setAjuste] = useState(0);
    const [productos, setProductos] = useState([]);
    const [pagos, setPagos] = useState([]);
    const [tipopagos, setTipopagos] = useState([]);
    const [montopagos, setMontoPagos] = useState([]);
    const [badmount, setBadMount] = useState(true);
    const [index, setIndex] = useState('null');
    const productsInputs = useRef([]);
    const pagosInputs = useRef([]);


    const validatedata = () => {

        if (parseInt(detalle.monto_total) === montoajuste) {
            notification.warning('El monto actual del recibo es igual al ajuste, no existen cambios.');
            return false;
        }

        if (montoajuste !== montopagos) {
            notification.warning('El monto agregado en el metodo de pago no es igual al monto total del ajuste.');
            return false;
        }

        if (!pagos.length) {
            notification.warning('No existen metodos de pago agregados.');
            return false;
        }

        let referencia = true;
        
        // eslint-disable-next-line
        pagos.map(item => {
            if (item.referencia && (item.referencia_numero === 0 || item.referencia_numero === '')) {
                referencia = false;
            }
        });

        if (!referencia) {
            notification.warning('Existe un tipo de pago sin referencia, debe agregar una referencia valida.');
            return false;
        }

        const payload = {
            boleta_id: boletaId,
            monto_total: montoajuste,
            monto_actual: detalle.monto_total,
            productos: parsedataproducts(),
            formas_pago: parsedatapagos(),
        }

        setPreloader(true);

        functions.ajustar(payload).then((response) => {
            if (response.registro_pagos) {
                notification.success('El ajuste fue realizado con exito.');
                toggle();
            } else {
                notification.success('Ocurrio un problema con el ajuste.');
            }
            setPreloader(false);
        });
    }


    const parsedataproducts = () => {
        return productos.map(item => {
            return {
                producto_id: item.id,
                precio_modificado: parseInt(item.precio_ajuste),
            }
        })
    }

    const parsedatapagos = () => {
        return pagos.map(item => {
            return {
                forma_pago: item.id,
                monto: parseInt(item.monto),
                referencia: item.referencia_numero || null,
            }
        })
    }

    useEffect(() => {
       if (pagos.length) {
           const sumPagos = pagos.reduce(function (acc, { monto }) {
                return acc + monto;
           }, 0);
           const badamount = montoajuste === sumPagos;
           setBadMount(!badamount);
           setMontoPagos(sumPagos);
       } else {
           setMontoPagos(0);
       }
       // eslint-disable-next-line
    },[pagos]);
    
    const agregarpagos = () => {
        if (index !== 'null') {
           const tipo = {
               ...tipopagos[index],
               monto: 0,
               referencia_numero: 0,
               uuid: uuidv4(),
           }
           let updateValues = [...pagos];
           updateValues.push(tipo);
           setPagos(updateValues);
        }
    }

    const toggle = () => {
        setVisible(!visible);
    }

    useEffect(() => {
        if (visible) {

            functions.detalle(boletaId).then((response) => {
                setDetalle(response.boleta);
                const formatproducst = response.boleta.boleta_producto.map(item => {
                    return {
                        ...item,
                        precio_ajuste: item.precio_modificado,
                    }
                })
                setProductos(formatproducst);
            });

            utils.formasPago().then((response) => {
                setTipopagos(response.tipoPagos);
            });
        }
    // eslint-disable-next-line
    },[visible])

    useEffect(() => {
        if (productos.length) {
            const sumValues = productos.reduce(function(acc, { cantidad, precio_ajuste }) {
                return acc + (cantidad * precio_ajuste);
            },0);
            setAjuste(sumValues);
        }
    },[productos])


    const customStyles = {
        rows: {
          style: {
            minHeight: '72px', // override the row height
          }
        },
        headCells: {
          style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
          },
        },
        cells: {
          style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
          },
        },
      };

      const productoslist = [
          {
            name: 'Producto',
            selector: row => row.producto.nombre_producto,
            sortable: true,
          },
          {
            name: 'Cantidad',
            selector: 'cantidad',
            sortable: true,
          },
          {
            name: 'Monto actual / Unitario ',
            selector: 'precio_modificado',
            sortable: true,
            cell: row => (
                utils.formatMoney(row.precio_modificado, 0, '.')
            )
          },
          {
            name: 'Ajuste',
            sortable: true,
            cell: row => (
                <div className="m-1">
                    <input
                    ref={(el) => productsInputs.current[row.id] = el}
                    type="text"
                    className="form-control"
                    defaultValue={row.precio_ajuste}
                    onBlur={(event) => changePriceColumn(event, row)}
                    onKeyPress={(event) => changePriceColumn(event, row)}
                    style={{ textAlign: 'right' }}
                    />
                </div> 
            )
          },
          {
            name: 'Total',
            sortable: true,
            cell: row => {
                const calculaamouts = row.cantidad * row.precio_ajuste;
                return utils.formatMoney(calculaamouts, 0, '.')
            }
          },
     ]

     const pagoslist = [
        {
          name: 'Tipo',
          selector: 'description',
          sortable: true,
          cell: row => {
            return <>
                <div onClick={() => removepago(row.uuid)} className={{ cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faTrash} color={'red'} />
                </div> 
                <div className="ml-2">{row.description}</div>
            </>
          }
        },
        {
          name: 'Referencia',
          sortable: true,
          cell: row => {
            if (row.referencia) {
              return <div className="m-1">
                    <input
                        ref={(el) => pagosInputs.current[row.id] = el}
                        type="text"
                        className="form-control"
                        defaultValue={row.referencia_numero}
                        onBlur={(event) => changePriceColumnPay(event, row, true, 'referencia_numero')}
                        onKeyPress={(event) => changePriceColumnPay(event, row, true, 'referencia_numero')}
                        placeholder="Ingrese referencia"
                        style={{ textAlign: 'right' }}
                    />
              </div> 
            } else {
                return '-';
            }
          }
        },
        {
          name: 'Monto',
          sortable: true,
          cell: row => (
            <div className="m-1">
            <input
                ref={(el) => pagosInputs.current[row.id] = el}
                type="text"
                className="form-control"
                defaultValue={row.monto}
                onBlur={(event) => changePriceColumnPay(event, row, false, 'monto')}
                onKeyPress={(event) => changePriceColumnPay(event, row, false, 'monto')}
                style={{ textAlign: 'right' }}
            />
      </div> 
          )
        },
   ]

    const changePriceColumn = (event, values) => {
        
        utils.onlyNumber(event);

        if (event.key === undefined || event.key === 'Enter') {
            const updateData = [...productos];
            const index = updateData.findIndex(val => val.uuid === values.uuid);
            if (index !== -1) {
                let value = event.target.value === '' ? updateData[index].precio_modificado : event.target.value;
                updateData[index].precio_ajuste = parseInt(value);
                productsInputs.current[values.id].blur();
            }
            setProductos(updateData);
        }
    }

    const changePriceColumnPay = (event, values, alphanumeric = false, field) => {
        
        if (!alphanumeric) {
            utils.onlyNumber(event);
        } 

        if (event.key === undefined || event.key === 'Enter') {
            const updateData = [...pagos];
            const index = updateData.findIndex(val => val.uuid === values.uuid);
            if (index !== -1) {
                let value = event.target.value === '' ? updateData[index][field] : event.target.value;
                updateData[index][field] = alphanumeric ? value : parseInt(value);
                pagosInputs.current[values.id].blur();
            }
            setPagos(updateData);
        }
    }

    const removepago = (uuid) => {
        const updateValues = [...pagos];
        const index = updateValues.findIndex(val => val.uuid === uuid);
        updateValues.splice(index, 1);
        setPagos(updateValues);
    }

    return (
        <>
        {config.tipo === 1 ?
            <button disabled={estado ? false : true } onClick={toggle}  className="btnx btnx-warn icon-table m-1">
                        <FontAwesomeIcon icon={faBalanceScaleLeft} />
            </button>
        : null}
        <Modal size={'xl'} show={visible}>
            <Card>
                { detalle ?
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center" style={{ borderRight: '1px dotted #cecece' }}>
                                <div className="d-flex flex-column">
                                    <div>Monto total actual</div>
                                    <h3>${utils.formatMoney(detalle.monto_total, 0, '.')}</h3>
                                </div>
                            </Col>
                            <Col className="d-flex justify-content-center" style={{ borderRight: '1px dotted #cecece' }}>
                                 <div className="d-flex flex-column">
                                    <div>Monto total ajuste</div>
                                    <h3>${utils.formatMoney(montoajuste, 0, '.')}</h3>
                                </div>
                            </Col>
                            <Col className="d-flex justify-content-center">
                                <button onClick={validatedata} type="button" className="btnx btnx-warn icon-table">
                                    <FontAwesomeIcon icon={faBalanceScaleLeft} /> Procesar ajuste
                                </button>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <DataTable
                                    noHeader={true}
                                    customStyles={customStyles}
                                    columns={productoslist}
                                    data={productos}
                                    dense={true}
                                    noDataComponent={'No existen productos agregados'}
                                />
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col lg={6}>
                                <small>Agregar metodo de pago</small>
                                <div className="d-flex">
                                    <select onChange={(ev) => setIndex(ev.target.value)} className="form-control">
                                        <option value="null">Seleccione...</option>
                                        {tipopagos.map((item, indx) => {
                                            return <option key={indx} value={indx}>{ item.description }</option>
                                        })}
                                    </select>
                                    <button  onClick={agregarpagos} type="button" className="btnx btnx-warn icon-table ml-2">
                                        <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                </div>
                            </Col>
                            <Col>
                               <small>Total en pagos agregados</small>
                               <h3 style={{ color: badmount ? 'red' : 'green' }}>${utils.formatMoney(montopagos, 0, '.')}</h3>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <DataTable
                                    noHeader={true}
                                    customStyles={customStyles}
                                    columns={pagoslist}
                                    data={pagos}
                                    dense={true}
                                    noDataComponent={'No existen metodos de pagos agregados'}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <button onClick={toggle} type="button" className="btnx btnx-warn icon-table">
                                     Cancelar
                                </button>
                            </Col>
                        </Row>
                    </>
                : null }
            </Card>
        </Modal>
        </>
    )
}
